export default __webpack_public_path__ + "static/media/desktop_mobile.46e18f33.jpg";